import axios from "axios";
import jwtDecode from "jwt-decode";

import { refresh } from "../lib/auth";
import { isCookieAuth } from "../lib/authProvider";

// ---------------------------------------------------------------------------
// Legacy JWT path helpers (unchanged)
// ---------------------------------------------------------------------------

const handleTokenExpired = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const { exp } = jwtDecode(accessToken);
  const currentTime = Date.now();
  const timeLeft = exp * 1000 - currentTime;
  return timeLeft >= 0;
};

// ---------------------------------------------------------------------------
// Shared
// ---------------------------------------------------------------------------

export async function call_api(
  url,
  method = "POST",
  payload = {},
  headers = {}
) {
  return await axios.request({
    url,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    data: payload,
    crossDomain: true,
    method,
  });
}

// ---------------------------------------------------------------------------
// Authenticated call — branches on active auth provider
// ---------------------------------------------------------------------------

export async function call_api_auth(
  url,
  method = "POST",
  payload = {},
  headers = {}
) {
  if (isCookieAuth()) {
    return callWithCookieAuth(url, method, payload, headers, false);
  }

  // ---- Legacy JWT path (no changes below this line) ----
  const accessToken = window.localStorage.getItem("accessToken");
  const token_is_valid = handleTokenExpired(accessToken);
  if (token_is_valid) {
    return await axios.request({
      url,
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
        ...headers,
      },
      data: payload,
      crossDomain: true,
      method,
    });
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
    window.location.href = "/auth/sign-in";
  }
}

// ---------------------------------------------------------------------------
// Cookie-path authenticated call with 401 → refresh → retry
// ---------------------------------------------------------------------------

async function callWithCookieAuth(url, method, payload, extraHeaders, isRetry) {
  try {
    return await axios.request({
      url,
      headers: {
        "Content-Type": "application/json",
        ...extraHeaders,
      },
      data: payload,
      crossDomain: true,
      withCredentials: true,
      method,
    });
  } catch (err) {
    if (err.response?.status === 401 && !isRetry) {
      const ok = await refresh();
      if (ok) {
        return callWithCookieAuth(url, method, payload, extraHeaders, true);
      }
      window.location.href = "/auth/sign-in";
      return;
    }
    throw err;
  }
}
